/** Customer-facing labels for risk review (aligned with Overview / Safety Report). */

export { displayEvidenceProofLabel as displayPatternEvidenceProofLabel } from '../overview/overviewDisplayLabels';
export {
  displayControlStatusLabel,
  displayControlStatusTooltip,
} from '../overview/controlStatusDisplay';

export function displayPatternWorkflowLabel(raw: string | null | undefined): string {
  const text = String(raw || '').trim();
  if (!text) return 'Needs review';
  const key = text.toLowerCase();
  if (key === 'exposed') return 'Control not verified';
  if (key.includes('control not verified')) return 'Control not verified';
  if (key.includes('owner assigned')) return 'Owner assigned';
  if (key.includes('needs review')) return 'Needs review';
  return text;
}
